<script lang="ts">
  import { untrack, type Snippet } from "svelte";
  import { appendFieldNameContext, dataField, registerFormState, type JSONObject } from "./dataFormLib.svelte";
  let {
    name,
    data,
    errors,
    value = $bindable(),
    formValue = $bindable(),
    nth = $bindable(),
    children
  } : {
    name? : string;
    data? : JSONObject;
    errors? : JSONObject;
    value? : JSONObject;
    formValue? : JSONObject;
    nth? : number | undefined;
    children : Snippet;
  } = $props()

  const formState = $derived({
    data: data || {},
    errors: errors || {}
  })
  const entireForm = registerFormState(()=>formState);
  formValue = entireForm.value as JSONObject;
  appendFieldNameContext(name);
  const field = dataField();
  $effect(()=>{
    let v = field.value as JSONObject;
    untrack(()=>value = v)
  })

  export function remove(){
    (field.value as JSONObject)._destroy = 1
  }

  $effect(()=>{ nth = field.nth })
</script>
{@render children()}